"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const functions_1 = require("@/common/functions");
function default_1({ size, heightSize, src, altSrc = '', additionalCss, altAfterImgWrapperCss, props, onClick, children, loading, }) {
    var _a;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: Object.assign(Object.assign({ position: 'relative', flexShrink: 0, width: `${size}px`, height: `${heightSize !== null && heightSize !== void 0 ? heightSize : size}px` }, additionalCss), { '&:after': (0, functions_1.afterImgWrapper)(altAfterImgWrapperCss) }) }, props, { onClick: onClick }, { children: [(0, jsx_runtime_1.jsx)("img", { src: (0, functions_1.getCdnUrl)(src) || altSrc, css: {
                    width: '100%',
                    height: '100%',
                    borderRadius: (_a = altAfterImgWrapperCss === null || altAfterImgWrapperCss === void 0 ? void 0 : altAfterImgWrapperCss.borderRadius) !== null && _a !== void 0 ? _a : '50%',
                    objectFit: 'cover',
                }, loading: loading, draggable: "false" }), children] })));
}
exports.default = default_1;
